import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { EducationService } from '../../../service/education/education.service';
import { Education } from '../../../class/education';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoEducation: Education;
    public education: Education;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public educationService: EducationService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
    }

    public cancelEducation () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/educations/education/education.component.ts